export default "__VITE_ASSET__10bb663c__"